export default {
	add_to_your_calendar: "Ajouter à votre calendrier",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explorez tout notre ensemble de cours, vidéos, articles et fichiers exclusifs.",
	home_drills_title: "Drills",
	home_events_title: "Mes Événements",
	home_keep_watching_title: "Continuer de regarder",
	home_library_title: "Bibliothèque",
	home_live_classes_title: "Cours en Direct",
	home_news_title: "Informations",
	home_online_courses_title: "Des Cours en ligne",
	home_podcasts_title: "Podcasts",
	home_surveys_title: "Sondages",
	home_tags_title: "Saillants",
	home_trails_title: "Pistes",
	home_webinars_title: "Webinaires",
	no_events_available_for_the_selected_date: "Aucun évènement n’est disponible.",
	welcome_to: "Bienvenue à",
	what_do_you_want_to_learn_today: "Que voulez-vous étudier aujourd’hui ?"
}